import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { IubireHero } from '../components/iubire/IubireHero';
import { IubireProblem } from '../components/iubire/IubireProblem';
import { IubireCurriculum } from '../components/iubire/IubireCurriculum';
import { IubireBenefits } from '../components/iubire/IubireBenefits';
import { IubireAbout } from '../components/iubire/IubireAbout';
import { IubireForWho } from '../components/iubire/IubireForWho';
import { IubirePricing } from '../components/iubire/IubirePricing';
import { IubireTestimonials } from '../components/iubire/IubireTestimonials';
import { IubireFAQ } from '../components/iubire/IubireFAQ';
export function IubirePage() {
  return <div className="min-h-screen bg-brand-cream font-body text-brand-text selection:bg-brand-gold selection:text-white overflow-x-hidden" data-id="element-2376">
      <Header data-id="element-2377" />
      <main data-id="element-2378">
        <IubireHero data-id="element-2379" />
        <IubireProblem data-id="element-2380" />
        <IubireCurriculum data-id="element-2381" />
        <IubireBenefits data-id="element-2382" />
        <IubireAbout data-id="element-2383" />
        <IubireForWho data-id="element-2384" />
        <IubirePricing data-id="element-2385" />
        <IubireTestimonials data-id="element-2386" />
        <IubireFAQ data-id="element-2387" />
      </main>
      <Footer data-id="element-2388" />
    </div>;
}